import { SystemStatus } from '../models/SystemStore/system';

export class ApiError extends Error {
  readonly cause?: Error;

  constructor(message: string, cause?: Error) {
    super(cause ? `${message}: ${cause.message}` : message);
    this.cause = cause;
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}

export class NotModifiedError extends ApiError {
  constructor(cause?: Error) {
    super('Not Modified', cause);
    Object.setPrototypeOf(this, NotModifiedError.prototype);
  }
}

interface GeneralErrorInfo {
  path?: string;
}

interface UpgradeAppErrorInfo {
  expose: boolean;
  statusCode: number;
  status: number;
  systemStatus: SystemStatus;
}

type ClientErrorInfo = GeneralErrorInfo | UpgradeAppErrorInfo;

export interface ClientErrorDetail {
  message: string;
  code: string;
  info?: ClientErrorInfo;
}

export class ClientError extends ApiError {
  readonly errorCode: number;
  readonly errorMessage: string;
  readonly errors: ClientErrorDetail[];

  constructor(
    errorCode: number,
    errorMessage: string,
    errors: ClientErrorDetail[],
    cause?: Error,
  ) {
    super(errorMessage, cause);
    this.errorCode = errorCode;
    this.errorMessage = errorMessage;
    this.errors = errors;
    Object.setPrototypeOf(this, ClientError.prototype);
  }

  haveError({ message, code }: Partial<ClientErrorDetail>) {
    return (
      this.errors.find((e) => e.message === message || e.code === code) !==
      undefined
    );
  }

  getErrorInfo({ message, code }: Partial<ClientErrorDetail>) {
    const error =
      this.errors.find((e) => e.message === message || e.code === code) ??
      this.errors[0];
    return error?.info;
  }
}

export class ServerError extends ApiError {
  readonly errorCode: number;
  readonly errorMessage: string;

  constructor(errorCode: number, errorMessage: string, cause?: Error) {
    super(errorMessage, cause);
    this.errorCode = errorCode;
    this.errorMessage = errorMessage;
    Object.setPrototypeOf(this, ServerError.prototype);
  }
}
